import { from } from 'rxjs';

import { getWalletEligibility, getWallets } from './api';
import { InsuranceProviders } from '../../enums/insurance-providers';

export const getWalletAndEligibilityData = async (defaultCurrency) => {
  try {
    const walletsData = await getWallets();
    const eligibilityResponse = await getWalletEligibility(defaultCurrency);
    const { eligibility: eligibilityData } = eligibilityResponse;
    const combinedDataDictionary = walletsData.reduce(
      (acc, wallet) => ({
        ...acc,
        [wallet.walletId]: {
          ...wallet,
          isWalletRegistered: wallet?.isSetupComplete,
          hasNewResources: false,
          hasWalletUpdate: false,
        },
      }),
      {},
    );
    eligibilityData.forEach((eligibility) => {
      const { walletId, newInsuranceProviderIds, newLabelProviderIds, newResourceUpdates } = eligibility;

      if (walletId) {
        const wallet = combinedDataDictionary[eligibility.walletId] ?? {};
        const { isWalletRegistered } = wallet;
        const hasNewResources =
          (newInsuranceProviderIds ?? []).length > 0 || (newLabelProviderIds ?? []).length > 0 || (newResourceUpdates ?? []).length > 0;
        // TODO MON-351: Remove this XCover only exclusion
        const hasOnlyXCoverEligibility =
          (newInsuranceProviderIds ?? []).length === 1 &&
          (newLabelProviderIds ?? []).length === 0 &&
          (newResourceUpdates ?? []).length === 0 &&
          `${newInsuranceProviderIds[0]}` === InsuranceProviders.XCover.insuranceProviderId;
        const isXCoverActivated = wallet.resources?.insuranceProviderIds?.includes(InsuranceProviders.XCover.insuranceProviderId);
        const shouldIgnoreUpdate = hasOnlyXCoverEligibility && isXCoverActivated;
        const hasWalletUpdate = isWalletRegistered && hasNewResources && !shouldIgnoreUpdate;

        combinedDataDictionary[eligibility.walletId] = {
          ...eligibility,
          ...wallet,
          hasNewResources,
          hasWalletUpdate,
        };
      } else {
        const hasNewResources =
          (newInsuranceProviderIds ?? []).length > 0 || (newLabelProviderIds ?? []).length > 0 || (newResourceUpdates ?? []).length > 0;
        combinedDataDictionary.newWallet = {
          ...eligibility,
          currencyCode: defaultCurrency,
          isSetupComplete: false,
          isWalletRegistered: false,
          hasNewResources,
          hasWalletUpdate: false,
        };
      }
    });
    return Object.values(combinedDataDictionary);
  } catch {
    return [];
  }
};

export const getWalletAndEligibilityDataObservable = (defaultCurrency) => {
  return from(getWalletAndEligibilityData(defaultCurrency));
};
